import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-refresh-properties-button', {
    maxWidth: '250px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

cssRule('.tb-refresh-properties-prompt', {
    marginBottom: '12px',
});

cssRule('.tb-details-refresh-properties-block-first', {
    paddingBottom: '12px',
});

cssRule('.tb-details-refresh-properties-block-last', {
    paddingTop: '12px',
    paddingBottom: 0,
});

cssRule('.tb-details-refresh-property-select-group-title', {
    position: 'relative',
});

cssRule('.tb-details-refresh-property-select-group-title-element', {
    display: 'inline-block',
});

cssRule('.tb-details-refresh-property-select-group-body', {
    paddingLeft: '21px',
});

cssRule('.tb-details-refresh-property-description', {
    color: applyColor(DesignTokens.color.font.default.subtle, '#999'),
    lineHeight: '16px',
});

cssRule('.tb-details-refresh-property-warn', {
    color: applyColor(DesignTokens.color.font.default.error, '#c41723'),
    lineHeight: '16px',
});

cssRule('.tb-details-refresh-property-select-selector, .tb-details-refresh-property-select-selector-narrow', {
    display: 'inline-block',
    width: '350px',
});

cssRule('.tb-details-refresh-property-select-selector-narrow', {
    width: '200px',
});

